import * as d3 from 'd3';
import React, { useEffect, useRef, useState } from 'react';
import * as Newick  from './utils/Newick'
import './GiChart.css';

function GiBarPlot(props:any) {
    const svgRef:any = useRef();
    const initData:any  = props.initialization;

    let tileFields:string[] = [];  
    let tileJoinField:any;

    if(initData.tile){
        tileFields = initData.tile.tile_fields;;
        tileJoinField = initData.tile.tile_join_field;
    }

    let barDatas: any[] = props.data;

    let bulkTileData: any = props.bulkTileData;
    let barDataDic: any = {}

    let width:number  = initData.width;
    let height:number = initData.height;
    let valueField:string = initData.value_field;// "vaf",
    let labelField:string = initData.label_field;//"bulk_id"
    let legendField:string = initData.legend_field;
    let valueLabelName:string = initData.value_label_name;

    let plotMargins = {
        top: 20,
        bottom: 100,
        left: 156, // 6 
        right: 150
        };

    if(barDatas){
        let tempHeight:number = (barDatas.length * 10) + plotMargins.top + plotMargins.bottom;

        if(initData.min_height != null && tempHeight < initData.min_height){
            height = initData.min_height;
        }else if(initData.max_height != null && tempHeight > initData.max_height){
            height = initData.max_height;
        }else{
            height = tempHeight;
        }
    }

    let tileNodeWidth:number = 30;
    let tileWidth:number = 0;

    let barplotWidth:number  = width - plotMargins.left - plotMargins.right;
    let barplotHeight:number = height - plotMargins.top - plotMargins.bottom;

    let labelNames:string[] = [];

    let medianValue:any;

    let colorCategoryValue:string[] = [];
    let colorCategoryMap:any = {};

    let yScale:any;
    let xScale:any;
    let xScaleOfTile:any;
    let color:any;
    let tileColor:any;
    const colorRange:string[] = ['#ff0000', '#4B0082','#FFACB7','#FFB400','#BC8F8F','#C71585','#B8860B','#8B0000','#006400','#8FBC8F','#1E90FF','#FF00FF','#8A2BE2','#EF904C','##FFFFE0']

    if(tileFields && tileFields.length > 0 && bulkTileData){
        tileWidth = tileNodeWidth * tileFields.length;
        barplotWidth = barplotWidth - tileWidth;

        tileColor = d3.scaleOrdinal()
                      .range(colorRange)
                      //.range(d3.schemeTableau10);

        xScaleOfTile = d3.scaleBand()
                      .domain(tileFields)
                      .range([0, tileWidth]);
    }


    if(barDatas){
 
        barDatas.sort((a, b) => a[valueField] - b[valueField])

        let maxTextLength:number = 0;

        barDatas.forEach(d => {
            d[valueField] = Number(d[valueField]);
            labelNames.push(d[labelField]);

            if(d[labelField].length > maxTextLength){
                maxTextLength = d[labelField].length;
            }

            barDataDic[d[labelField]] = d;

            if(colorCategoryMap[d[legendField]] === undefined){
                colorCategoryMap[d[legendField]] = d[legendField];
                colorCategoryValue.push(d[legendField]);
            }

            if(initData.bar_plot_value){
                let [lowerValue, middleValue, HigherValue] = initData.bar_plot_value(d);
                d.plotValue = {
                    lower: lowerValue,
                    middle: middleValue,
                    higher: HigherValue
                };
            }
        })

        plotMargins.left = maxTextLength * 5.8;

        colorCategoryValue.sort();

        let maxValue = d3.max(barDatas, d => d.plotValue ? d.plotValue.higher : d[valueField]);

        medianValue = d3.median(barDatas, d => d[valueField]);
        
        yScale = d3.scaleBand()
                    .domain(labelNames)
                    .range([barplotHeight, 0]);

        xScale = d3.scaleLinear()
                    .domain([0, maxValue + (maxValue/10)])
                    .range([0, barplotWidth]);

        color = d3.scaleOrdinal()
                      .domain(colorCategoryValue)
                      .range(colorRange);
                      //.range(d3.schemeCategory10)

        barDatas.forEach(d => {
                      d.color = color(d[legendField]);
        })
    }

    function mouseoveredOnLabel(active:boolean ){
        return function(this: any, event: any, d: any) {

            let data:any = barDataDic[d];

            if(d3.select(this).classed("selected") === undefined){
                d3.select(this).classed("selected", false).raise();
            }

            if(d3.select(this).classed("selected") === false) {
                if(active){
                    d3.select(this).attr("fill", data.color);
                } else {
                    d3.select(this).attr("fill", "#000");
                }

                d3.select(this).classed("label--active", active);
                d3.select(data.barNode).classed("bar--active", active);

                data.tileNodes.forEach( (tileNode:any) => {
                    d3.select(tileNode).classed("bar--active", active);
                });

                data.selected = active;

                let isOtherSeleted:boolean = false;

                barDatas.forEach(function(bardata:any) {
                    if(bardata !== data && bardata[legendField] === data[legendField] && bardata.selected ){
                        isOtherSeleted = true;
                        return true;
                    }
                })
                if(initData.callback_after_mouseover_label){
                    if(isOtherSeleted === false){
                        initData.callback_after_mouseover_label(data, active)
                    }else{
                        initData.callback_after_mouseover_label(data, true)
                    }
                }
            }
            
        }
    }

    // Click with Label
    function mouseClickOnLabel(){
        return function(this: any, event: any, d: any) {
            let data:any = barDataDic[d];
            let selected:any = d3.select(this).classed("selected");

            if(selected === undefined || selected === false){
                selected = true
            }else{
                selected = false;
            }

            d3.select(this).classed("selected", selected).classed("link--active", selected).raise();
            
            if(initData.callback_after_mouseclick_label){
                initData.callback_after_mouseclick_label(data, selected, bulkTileData)
            }
        }
    }

    useEffect(() => {
        if(barDatas){
            const svg:d3.Selection<SVGGElement, any, any, any> = d3.select(svgRef.current)  
                                                                // .attr('width', width)
                                                                // .attr('height', height)
                                                                .attr("viewBox", `0 0 ${width} ${height}`)
                                                                .attr("preserveAspectRatio","xMidYMid meet")
                                                                ;
            // initialization
            svg.selectAll("g").remove();

            let transformLeft:number = plotMargins.left;

            if(tileFields && tileFields.length && bulkTileData){
                transformLeft = transformLeft + tileWidth ;
            }

            let tileGroup:d3.Selection<SVGGElement, any, any, any> = svg.append('g')
                                                                        .classed('tiles', true)
                                                                        .attr('transform', `translate(${plotMargins.left},${plotMargins.top})`);

            let barplotGroup:d3.Selection<SVGGElement, any, any, any> = svg.append('g')
                                                                        .classed('barplot', true)
                                                                        .attr('transform', `translate(${transformLeft},${plotMargins.top})`);
        
            let yAxis = tileGroup.append("g")
                                 .call(d3.axisLeft(yScale))

            yAxis.selectAll("text")
                 .each(function(d:any, i:number){
                            barDataDic[d].labelNode = this;
                 })
                 .attr('font-family', 'Helvetica Neue, Helvetica, sans-serif')
                 .attr('font-size', '10px')
                 .attr('color', "#000")
                 .on("mouseover", mouseoveredOnLabel(true))
                 .on("mouseout", mouseoveredOnLabel(false))
                 .on("click", mouseClickOnLabel())
                 .style("cursor", "pointer");
            
            let xAxis = barplotGroup.append("g")
                                    .attr('transform', `translate(0,${barplotHeight})`)
                                    .call(d3.axisBottom(xScale))
                                    .selectAll("text")	
                                    .attr("dx", "9px")

            if(tileFields && tileFields.length && bulkTileData){

                
                tileGroup.append("g")
                         .attr('transform', `translate(0,${barplotHeight})`)
                         .call(d3.axisBottom(xScaleOfTile))
                         .selectAll("text")	
                         .style("text-anchor", "end")
                         .attr("dx", "-.8em")
                         .attr("dy", "-2px")
                         .attr("transform", "rotate(-65)")
                         .attr('font-family', 'Helvetica Neue, Helvetica, sans-serif')
                         .attr('font-size', '10px');
            }
 
            // bar
            let barHeight:number = (barplotHeight / barDatas.length) - 4
            let correctionY:number = (barHeight / 3) + 0.2;
            
            barplotGroup.append("g")
                    .selectAll("rect")
                    .data(barDatas)
                    .enter()
                    .append("rect")
                    .each(function(d:any) { d.barNode = this; })
                    .attr("fill", d => d.color)
                    .attr("opacity", "0.75")
                    .attr("stroke", "black")
                    .attr("stroke-width", 0)
                    .attr("x", 0)
                    .attr("y", function(d:any){
                        return yScale(d[labelField]) + correctionY ;
                    })
                    .attr("width", function(d:any){
                        return xScale(d[valueField]);
                    })
                    .attr("height", barHeight);

            // tiles
            if(tileFields && tileFields.length && bulkTileData){
                let tileHeight:number = (barplotHeight / barDatas.length)

                let tileX = 0;
                tileFields.forEach(tileField => {
                    // Draw tiles
                    tileGroup.append("g")
                            .selectAll("rect")
                            .data(barDatas)
                            .enter()
                            .append("rect")
                            .each(function(d:any) { 
                                if(d.tileNodes === undefined){
                                    d.tileNodes = [];
                                }
                                d.tileNodes.push(this); 
                            })
                            .attr("fill", function(d:any){
                                let tileData:any = bulkTileData[d["bulk_id"]];

                                return tileColor(tileData[tileField]);
                                
                            })
                            .attr("x", xScaleOfTile(tileField))
                            .attr("y", function(d:any){
                                return yScale(d[labelField]) ;
                            })
                            .attr("width", function(d:any){
                                return tileNodeWidth;
                            })
                            .attr("height", tileHeight)
                            .attr("opacity", "0.75")
                            .attr("stroke", "black")
                            .attr("stroke-width", 0.2);
                    tileX++;
                })


            }


            // plot
            //d.plotValue
            if(initData.bar_plot_value){
                const plotG = barplotGroup.append("g")
                                .selectAll("line")
                                .data(barDatas)
                                .join("g");


                plotG.append('line')
                     .filter(function(d) { return (d.plotValue.lower > 0) })
                            .attr('x1', function(d:any){return xScale(d.plotValue.lower)})
                            .attr('y1', function(d:any){
                                return yScale(d[labelField])+ correctionY -2 ;
                            })
                            .attr('x2', function(d:any){return xScale(d.plotValue.lower)})
                            .attr('y2', function(d:any){
                                return yScale(d[labelField]) + barHeight + correctionY +2 ;
                            })
                            .attr("stroke", "black")
                            .attr("stroke-width", "1px")
                            .attr("opacity", "0.8");

                plotG.append('line')
                     .filter(function(d) { return (d.plotValue.lower > 0) })
                            .attr('x1', function(d:any){return xScale(d.plotValue.higher)})
                            .attr('y1', function(d:any){
                                return yScale(d[labelField])+ correctionY -2 ;
                            })
                            .attr('x2', function(d:any){return xScale(d.plotValue.higher)})
                            .attr('y2', function(d:any){
                                return yScale(d[labelField]) + barHeight + correctionY +2 ;
                            })
                            .attr("stroke", "black")
                            .attr("stroke-width", "1px")
                            .attr("opacity", "0.8");

                // plotG.append('line')
                //             .attr('x1', function(d:any){return xScale(d.plotValue.middle)})
                //             .attr('y1', function(d:any){
                //                 return yScale(d[labelField])+ correctionY - 2 ;
                //             })
                //             .attr('x2', function(d:any){return xScale(d.plotValue.middle)})
                //             .attr('y2', function(d:any){
                //                 return yScale(d[labelField]) + barHeight + correctionY +2 ;
                //             })
                //             .attr("stroke", "black")
                //             .attr("stroke-width", "1px")
                //             .attr("opacity", "0.8");

                plotG.append('line')
                     .filter(function(d) { return (d.plotValue.lower > 0) })
                            .attr('x1', function(d:any){return xScale(d.plotValue.lower)})
                            .attr('y1', function(d:any){
                                return yScale(d[labelField])+ (barHeight / 2) +correctionY;
                            })
                            .attr('x2', function(d:any){return xScale(d.plotValue.higher)})
                            .attr('y2', function(d:any){
                                return yScale(d[labelField]) + (barHeight / 2) + correctionY;
                            })
                            .attr("stroke", "black")
                            .attr("stroke-width", "1px")
                            .attr("opacity", "0.8");
                            
            }

            // median line
            barplotGroup.append('g')
            .append('line')
            .attr('x1', xScale(medianValue))
            .attr('y1', 0)
            .attr('x2', xScale(medianValue))
            .attr('y2', barplotHeight)
            .attr("stroke", "#ff0000")
            .attr("stroke-width", "1.5px")
            .attr("opacity", "0.8");

            const lineValues:number[] = [medianValue * 0.75, medianValue + (medianValue * 0.25)];

            barplotGroup.append('g')
               .selectAll('line')
               .data(lineValues)
               .enter()
               .append('line')
               .attr('x1', d => xScale(d))
               .attr('y1', 0)
               .attr('x2', d => xScale(d))
               .attr('y2', barplotHeight)
               .attr("stroke", "#ff4500")
               .attr("stroke-width", "1.5px")
               .attr("opacity", "0.8")
               .attr("stroke-dasharray", "4,4");

            // valueLabelName
            barplotGroup.append("g")
                        .append("text")
                        .attr('color', "#000")
                        .attr("dx", barplotWidth/2 - 30)
                        .attr("y", 1)
                        .attr("dy", barplotHeight + 35)
                        .attr('font-family', 'Helvetica Neue, Helvetica, sans-serif')
                        .attr('font-size', '12px')
                        .attr('font-weight', 'bold')
                        .text(valueLabelName);

            // legend
            let index = 0;
            const legendG:any = svg.append("g")
                            .selectAll("g")
                            .data(color.domain())
                            .join("g")
                            .attr("transform", (d, i) => `translate(${(width - plotMargins.right + 20)},${15 + (index++) * 10})`);
        
            legendG.append("rect")            
                .attr("width",8)
                .attr("height", 8)
                .attr("fill", function(d:any){return String(color(d))});
        
            legendG.append("text")
                   .attr("x", 14)
                   .attr("y", 1)
                   .attr("dy", 6)
                   .attr('font-family', 'Helvetica Neue, Helvetica, sans-serif')
                   .attr('font-size', '10px')
                   .text(function(d:any){return d})

            // tile legend
            if(tileFields && tileFields.length && bulkTileData){
                index += 10;

                const tileLegendG:any = svg.append("g")
                                            .selectAll("g")
                                            .data(tileColor.domain())
                                            .join("g")
                                            .attr("transform", (d, i) => `translate(${(width - plotMargins.right + 20)},${15 + (index++) * 10})`);

                tileLegendG.append("rect")
                        .attr("width",8)
                        .attr("height", 8)
                        .attr("fill", function(d:any){return String(tileColor(d))});

                tileLegendG.append("text")
                        .attr("x", 14)
                        .attr("y", 1)
                        .attr("dy", 6)
                        .attr('font-family', 'Helvetica Neue, Helvetica, sans-serif')
                        .attr('font-size', '10px')
                        .text(function(d:any){return d})       
            }
        }
    }, [barDatas]);
    
    return (
        <React.Fragment>
            <svg ref={svgRef}>
            </svg>
        </React.Fragment>
    );
}

export default GiBarPlot;